export default "__VITE_PUBLIC_ASSET__e4a3cfb0__"